import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import SolutionPage from "@/pages/SolutionPage";
import WhoPage from "@/pages/WhoPage";
import SectorPage from "@/pages/SectorPage";
import FeaturesPage from "@/pages/FeaturesPage";
import ModulePage from "@/pages/ModulePage";
import PricingPage from "@/pages/PricingPage";
import DemoPage from "@/pages/DemoPage";
import LegalPage from "@/pages/LegalPage";
import BlogPage from "@/pages/BlogPage";
import ArticlePage from "@/pages/ArticlePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPage from "@/pages/AdminPage";
import AcceptInvitation from "@/pages/AcceptInvitation";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
      return () => clearTimeout(timer);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-white">
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/solution" element={<SolutionPage />} />
        <Route path="/pour-qui" element={<WhoPage />} />
        <Route path="/secteurs/:slug" element={<SectorPage />} />
        <Route path="/fonctionnalites" element={<FeaturesPage />} />
        <Route path="/fonctionnalites/:moduleId" element={<ModulePage />} />
        <Route path="/tarifs" element={<PricingPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/ressources" element={<BlogPage />} />
        <Route path="/ressources/:slug" element={<ArticlePage />} />
        <Route path="/mentions-legales" element={<LegalPage kind="notice" />} />
        <Route path="/cgu" element={<LegalPage kind="terms" />} />
        <Route path="/confidentialite" element={<LegalPage kind="privacy" />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/invitation/:token" element={<AcceptInvitation />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      {!isAdmin && <Footer />}
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <Shell />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
